import { useQuery } from "@tanstack/react-query";
import {
  getAdminResellerTopListApi,
  getResellerTopListApi,
} from "../api/resellerTopListApi";

export const ADMIN_TOP_LIST_QUERY_KEY = ["admin", "topList"];
export const RESELLER_TOP_LIST_QUERY_KEY = ["reseller", "topList"];

const DEFAULT_RESELLER_TOP_LIMIT = 5;

export const useAdminResellerTopListQuery = (month: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: [...ADMIN_TOP_LIST_QUERY_KEY, month],
    queryFn: () => getAdminResellerTopListApi(month),
    enabled: enabled,
  });
};

export const useResellerTopListQuery = (
  resellerId: string | undefined,
  month: string,
  limit: number = DEFAULT_RESELLER_TOP_LIMIT,
) => {
  return useQuery({
    queryKey: [...RESELLER_TOP_LIST_QUERY_KEY, resellerId, month, limit],
    queryFn: () =>
      getResellerTopListApi(resellerId!, month, limit),
    enabled: !!resellerId,
  });
};